<template>
  <form ref="form" class="message_form" id="contact" v-on:submit.prevent="handleSubmit">
    <div class="row small-collapse medium-collapse large-collapse di">
      <div class="large-6 column">
        <label class="label">{{$t("yourEmailAddressText")}}</label>
        <input v-model="email" id="email" type="text" name="email" :placeholder="enterEmail">
        <div
          :class="errEmail"
          id="email-err"
          class="notification notification-error notification-inline half"
        >{{inputErr.email}}</div>
      </div>

      <div class="large-6 column">
        <label class="label">{{$t("subjectText")}}</label>
        <input
          v-model="subject"
          id="subject"
          type="text"
          name="subject"
          :placeholder="enterSubject"
        >
        <div
          id="subject-err"
          :class="errSubject"
          class="notification notification-error notification-inline half"
        >{{inputErr.subject}}</div>
      </div>

      <div class="medium-12 column textarea">
        <label class="label">{{$t("requestDescriptionText")}}</label>
        <textarea v-model="description" id="message" name="message" :placeholder="enterMessage"></textarea>
        <div
          :class="errDescription"
          id="description-err"
          class="notification notification-error notification-inline half"
        >{{inputErr.description}}</div>
      </div>
      <div class="input-group">
        <label class="label" for="file-upload">{{$t('requestAttachmentsText')}}</label>
        <component v-bind:is="fileUploadComponent"></component>
      </div>
      <button type="submit">{{$t('sendMessageText')}}</button>
    </div>
    <div
      tabindex="0"
      ref="errorEl"
      id="general-error"
      class="notification notification-error notification-inline full"
      style="color: red;display: none;"
    >{{errorMessage}}</div>
    <button
      style="visibility: hidden;"
      id="recaptcha"
      class="g-recaptcha"
      v-bind="{
            'data-sitekey':`${siteKey}`,
            'data-callback': `myRecaptchaHandler`,
            'data-badge': 'inline'
            }"
    ></button>
  </form>
</template>

<script>
import { getComponent, handleRequestSubmit, eventBus } from '@/utils/common';
import VueRecaptcha from 'vue-recaptcha';

export default {
  data() {
    return {
      siteKey: process.env.RECAPTCHA_SITEKEY,
      errorMessage: '',

      // variables for input values
      description: '',
      email: '',
      subject: '',
      // values for the error display fields
      inputErr: {
        description: '',
        email: '',
        subject: ''
      },
      // booleans for determining if to display the error message
      errDisplay: {
        description: false,
        email: false,
        subject: false
      }
    };
  },
  mounted() {
    window.grecaptcha.render('recaptcha');
    // the handler for the captcha is defined on a property therefore it wont have access to this scope
    window.myRecaptchaHandler = this.recaptchaSucces;
  },
  components: { VueRecaptcha },
  computed: {
    enterMessage() {
      return this.$t('enterMessage');
    },
    enterEmail() {
      return this.$t('enterEmail');
    },
    enterSubject() {
      return this.$t('enterSubject');
    },
    fileUploadComponent() {
      return getComponent(this.$store.getters.flowObject, 'fileUpload');
    },
    errEmail() {
      return {
        'hide-err': !this.errDisplay.email,
        'show-err': this.errDisplay.email
      };
    },
    errDescription() {
      return {
        'hide-err': !this.errDisplay.description,
        'show-err': this.errDisplay.description
      };
    },
    errSubject() {
      return {
        'hide-err': !this.errDisplay.subject,
        'show-err': this.errDisplay.subject
      };
    }
  },
  methods: {
    recaptchaSucces() {
      this.clearErrors();
      handleRequestSubmit(this.email, this.subject, this.description)
        .then(response => {
          this.email = '';
          this.subject = '';
          this.description = '';
          eventBus.requestSuccess(true);
        })
        .catch(error => {
          let formFields = this.$refs.form.elements;
          if (error.response && error.response.data.message === 'reCaptcha authentication failed') {
            this.displayGeneralError(this.$t('requestCaptchaFailed'));
            window.grecaptcha.reset();
          } else if (error.message === 'file upload still in progress') {
            this.displayGeneralError(this.$t('requestUploadInProgress'));
          } else if (
            (error.response && error.response.data.message === 'invalid email address') ||
            error === 'invalid email address'
          ) {
            this.inputErr.email = this.$t('invalidEmail');
            this.errDisplay.email = true;
            formFields['email'].focus();
          } else if (error.message === 'missing fields') {
            let goToElement = '';
            error.fields.forEach(field => {
              this.inputErr[field] = this.$t(`missing-${field}`);
              this.errDisplay[field] = true;
              // ensure we focus on the very first input field that's invalid and not the last
              if (!goToElement) {
                goToElement = field;
              }
            });
            formFields[goToElement].focus();
          } else {
            this.displayGeneralError(this.$t('requestErrorMessage'));
          }
        });
    },
    handleSubmit() {
      if (window.grecaptcha.getResponse() === '') {
        return window.grecaptcha.execute();
      }
      this.recaptchaSucces();
    },
    displayGeneralError(message) {
      let errorEl = this.$refs.errorEl;
      errorEl.focus();
      this.errorMessage = message;
      errorEl.style.display = 'block';
      errorEl.focus();
    },
    clearErrors() {
      this.$refs.errorEl.style.display = 'none';
      this.errDisplay = {
        email: false,
        description: false,
        subject: false
      };
      this.inputErr = {
        email: '',
        description: '',
        subject: ''
      };
    }
  }
};
</script>
<style lang="scss" scoped>
@media (min-width: 1024px) {
  .large-6 {
    width: 49%;
    padding-left: 0;
    padding-right: 0;
    display: inline-block;
  }
}

.message_form input[type='text'],
.message_form textarea {
  margin-bottom: 20px;
}
.message_form button[type='submit'] {
  margin-bottom: 20px;
}
#general-error {
  margin-bottom: 20px;
  text-align: center;
}

.message_form input {
  margin-top: 4px;
  border: 1px solid #e0e0e0;
  height: 45px;
  border-radius: 6px;
  padding: 5px 15px;
  outline: 0;
}
.message_form dev span {
  font-size: 13px;
  font-weight: 600;
}
.message_form textarea {
  margin-top: 4px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  padding: 10px 0 0 15px;
  outline: 0;
  min-height: 120px;
  resize: none;
}
@media screen and (min-width: 1024px) {
  .message_form textarea {
    width: 96%;
  }
  .message_form input {
    width: 96%;
  }
  .notification.half {
    width: 96%;
  }
}
@media screen and (max-width: 1023px) {
  .message_form input,
  .message_form textarea {
    width: 100%;
  }
  .notification.half {
    width: 100%;
  }
}
.message_form button {
  margin: 20px 5px 0 0;
  color: #666;
  display: inline-block;
  padding: 15px 34px;
  font-weight: 500;
  border: 1px solid #93cb53;
  font-size: 13px;
  border-radius: 24px;
  font-weight: 500;
  -webkit-transition: background-color 0.4s, color 0.3s;
  transition: background-color 0.4s, color 0.3s;
  outline: 0;
}
.message_form button:hover {
  color: #fff;
  background-color: #93cb53;
  cursor: pointer;
}
.notification-inline.notification-error {
  background-color: #f4dfde;
  border: 1px solid #e03b30;
  color: red;
}
.notification {
  border: 1px solid;
  //   display: table;
  font-family: sans-serif;
  font-size: 12px;
  padding: 15px 15px 15px 15px !important;
  transition: height 0.2s;
  color: #555;
}
.notification.full {
  width: 96%;
}

.notification-inline {
  border-radius: 4px;
  font-weight: 100;
  line-height: 14px;
  margin-top: 5px;
  padding: 5px;
  position: relative;
  text-align: left;
  vertical-align: middle;
}
.notification-error {
  background: #ffeded;
}
.notification-inline.notification-error::before {
  border-radius: 50%;
  border: 1px solid red;
  color: red;
  content: '!';
  display: inline-block;
  font-family: sans-serif;
  font-size: 8px;
  font-weight: normal;
  height: 12px;
  line-height: 12px;
  margin: -2px 5px 0 0;
  text-align: center;
  vertical-align: middle;
  width: 12px;
}
.show-err {
  display: block;
}
.hide-err {
  display: none;
}
</style>
